module.exports = __webpack_public_path__ + "static/img/wbs.e538b94.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/media/wbs.jpg
// module id = zeJe
// module chunks = 0